export default {
  methods: {
    updateComponentConfigGroup({swatchId, componentName, swatchObj, componentGroup, color = null}) {
      return new Promise((resolve, reject) => {
        if (!swatchObj?.component_config_groups) {
          this.$recipe.updateComponents(componentName, swatchId, componentGroup, null, color);
          return resolve();
        }
        this.$store.dispatch("componentConfigGroup/GET_COMPONENT_GROUPING_BY_SWATCH", { swatchId , componentName })
          .then(group => {
            if (group && Object.keys(group).length > 0) {
              this.updateRecipeGroup({group});
            } else {
              this.$recipe.updateComponents(componentName, swatchId, componentGroup, null, color);
            }
            resolve();
          }).catch(reject);
      });
    },
    updateRecipeGroup({group}) {
      const recipeGroup = Object.keys(group);
      recipeGroup.forEach(componentName => {this.$recipe.update(componentName, group[componentName])})
    }
  },
};
